export const insurances = [
  {
    name: "Select",
    value: "",
  },
  {
    name: "CBHS",
    value: "CBHS",
  },
  {
    name: "OSHC",
    value: "OSHC",
  },
  {
    name: "nib",
    value: "nib",
  },
  {
    name: "Allianz Care",
    value: "Allianz Care",
  },
  {
    name: "Medibank",
    value: "Medibank",
  },
  {
    name: "Bupa",
    value: "Bupa",
  },
];
export const types = [
  {
    name: "Select",
    value: "",
  },
  {
    name: "Single",
    value: "Single",
  },
  {
    name: "Family",
    value: "Family",
  },
  {
    name: "Couple",
    value: "Couple",
  },
];
